// extracted by mini-css-extract-plugin
export default {"action":"_9a5e0d08d6db42a5"};